import * as React from "react";
import { RouteComponentProps } from "react-router";
import * as Dati from "./Dati";
import { Trad } from "./components/";
import moment from "moment";
import $ from "jquery";
import { InputStringa, InputTesto, InputImporto, InputPercentuale, InputData, InputCheckBox, InputNumero, InputCAP, InputComune, InputProvincia } from "./components/";

export const Version = "2109.08.204.02";

export const ValutaIcona = "fa-euro-sign";
export const ValutaSimbolo = "€";

export enum TTipiGlobale {
    Locale = 1,
    Sessione,
    Menu,
    Dialog
}

export const Languages: string[] = ["en", "it"];

type TGlobale = { [G: number]: any };

export interface IGlobaleState {
    Globale: TGlobale;
}

export function isNumber(value: string | number): boolean {
    return !isNaN(Number(value.toString()));
}

export const ChiamaAPINonAttivo = -1;

/* ------------------------------------------------------- */

export interface IGlobaleProps {
    Globale: TGlobale;
    SetGlobale: (G: number, V: any) => void;
    //TODO Trovare una modalità più smart
    //TODO Trovata (tramite funzioni anonime)... da trasferire su questo progetto
    SetLocale: (V: CLocale) => void;
    SetSessione: (V: CSessione) => void;
    SetMenu: (V: CMenu) => void;
    SetDialog: (V: CDialog) => void;

    //var S = Glob.GetSessione();
    //S.Utente += 1;
    //this.props.SetGlobale(Glob.TTipiGlobale.Sessione, S);
}

export class CSessione {
    Sessione = "";
    Scadenza: Date = new Date();
    ScadenzaMax: Date = new Date();
    ID_Utente = 0;
    ID_UtenteImpersonato = 0;
    Login = "";
    Livello = 0;
    ID_Anag = 0;
    Immagine = "";
    Nome = "";
    Cognome = "";
    Email = "";
    Autorizzazioni: Dati.Dictionary<number> = {};
    Limiti = new Dati.CRisAPI_DatiLimiti();
    Gruppi: string[] = [];
    ConfigurazioneCompilazione = "";
    Versione = "";
}

export class CLocale {
    Lingua: string = Trad.Lingua;
    Valuta = "eur";
}

export class CMenu {
    Main = "";
    ID_MenuMain = 0;
    VariabiliMenu: { [D: string]: string } = {};
}

export type DialogType = "info" | "warning" | "success" | "error";

export class CDialog {
    Open: boolean = false;
    Title: string = "";
    Content: string = "";
    Type: DialogType = "info";
}

/* ------------------------------------------------------- */
export class Globale {
    public G: TGlobale = {};
    public static Init(): TGlobale {
        let Locale = new CLocale();
        let Sessione = new CSessione();
        let Menu = new CMenu();

        let LS = localStorage.getItem("Sessione");
        if (LS != null && LS != "null") {
            try {
                Sessione = JSON.parse(LS);
            } catch (e) {
                Sessione = new CSessione();
            }
        }
        LS = localStorage.getItem("Menu");
        if (LS != null && LS != "null") {
            try {
                Menu = JSON.parse(LS);
            } catch (e) {
                Menu = new CMenu();
            }
        }
        LS = localStorage.getItem("Locale");
        if (LS != null && LS != "null") {
            try {
                Locale = JSON.parse(LS);
            } catch (e) {
                Locale = new CLocale();
            }
        }

        //Lo stato globale viene salvato per averlo sempre disponibile per le fuzioni Glob.Get*
        G.G = {
            [TTipiGlobale.Locale]: Locale,
            [TTipiGlobale.Sessione]: Sessione,
            [TTipiGlobale.Menu]: Menu,
            [TTipiGlobale.Dialog]: new CDialog()
        };

        Trad.Lingua = Locale.Lingua;
        moment.locale(Locale.Lingua);

        return G.G;
    }
}

//Lo stato globale viene salvato per averlo sempre disponibile per le fuzioni Glob.Get*
const G = new Globale();

export function GetLocale(): CLocale {
    return G.G[TTipiGlobale.Locale];
}

export function GetSessione(): CSessione {
    return G.G[TTipiGlobale.Sessione];
}

export function GetMenu(): CMenu {
    return G.G[TTipiGlobale.Menu];
}

//TODO Passare ad una gestione dei limiti lato server
export function GetLimite(id_TipoGruppoLimite: string, id_TipoProdotto?: number): number {
    const Limiti = GetSessione().Limiti.Dati;
    for (let i = 0; i < Limiti.length; i++) {
        if (Limiti[i].ID_TipoGruppoLimite == id_TipoGruppoLimite && (id_TipoProdotto != undefined ? Limiti[i].ID_TipoProdotto == id_TipoProdotto : true)) {
            return Limiti[i].Valore;
        }
    }
    return 0;
}

export type DatiJSON = string;

/* ------------------------------------------------------- */

export interface IRouteGlobaleProps extends RouteComponentProps<{}>, IGlobaleProps { }

export const IntervalloControlloSessione = 5 * 1000; //5 secondi

export function DataValore(Data?: Date): string {
    if (Data == undefined || Data == null) {
        return "";
    } else {
        return moment(Data).format("YYYY-MM-DD");
    }
}

export function DataValoreStringa(Data: string): string {
    if (Data == undefined || Data == null) {
        return "";
    } else {
        return moment(Data).format("YYYY-MM-DD");
    }
}

export function DataValoreTrad(Data?: Date): string {
    if (Data == undefined || Data == null) {
        return "";
    } else {
        return Trad.TradParam("{1-D}", [Data]);
    }
}

export function DataValoreStringaTrad(Data: string): string {
    if (Data == undefined || Data == null) {
        return "";
    } else {
        return Trad.TradParam("{1-D}", [moment(Data).toDate()]);
    }
}

export enum LogCat {
    API = "API",
    Azioni = "Azioni",
    BaseComponent = "BaseComponent",
    BaseComponentSettaValore = "BaseComponentSettaValore",
    Form = "Form",
    InfoModale = "InfoModale",
    InputCalcolatore = "InputCalcolatore",
    Menu = "Menu",
    Reducer = "Reducer",
    Regole = "Regole",
    Sessione = "Sessione",
    Stampa = "Stampa",
    Tipi = "Tipi",
    Trad = "Trad"
}

class CLogCatStato {
    LogAbilitato: { [LC: number]: boolean } = {};
}

export function LogAbilita(abilitato: boolean, logcat?: LogCat): CLogCatStato {
    let LCS = new CLogCatStato();

    const LCSS = localStorage.getItem("LogCatStato");
    if (LCSS != null && LCSS != "null") {
        try {
            LCS = JSON.parse(LCSS);
        } catch (e) { }
    }

    for (const LC in LogCat) {
        if (LCS.LogAbilitato[LC as any] == undefined) {
            LCS.LogAbilitato[LC as any] = false;
        }
    }

    if (logcat != undefined) {
        LCS.LogAbilitato[logcat as any] = abilitato;
        localStorage.setItem("LogCatStato", JSON.stringify(LCS));
    }
    return LCS;
}

export function LogInfo(logcat: LogCat, message?: any, ...optionalParams: any[]) {
    let LCS = new CLogCatStato();

    const LCSS = localStorage.getItem("LogCatStato");
    if (LCSS != null && LCSS != "null") {
        try {
            LCS = JSON.parse(LCSS);
        } catch (e) { }
    }

    if (LCS.LogAbilitato[logcat as any]) {
        console.info(logcat + "-" + message, ...optionalParams);
    }
}

export function Log(logcat: LogCat, err: boolean, message?: any, ...optionalParams: any[]) {
    let LCS = new CLogCatStato();

    const LCSS = localStorage.getItem("LogCatStato");
    if (LCSS != null && LCSS != "null") {
        try {
            LCS = JSON.parse(LCSS);
        } catch (e) { }
    }

    if (LCS.LogAbilitato[logcat as any]) {
        if (err) {
            console.warn(logcat + "-ERR " + message, ...optionalParams);
        } else {
            console.warn(logcat + "-" + message, ...optionalParams);
        }
    }
}

export function TagliaStringa(stringa: string | undefined, lung: number) {
    if (stringa == undefined) {
        return "";
    } else if (stringa.length <= lung) {
        return stringa;
    } else {
        return stringa.substr(0, lung - 3) + "...";
    }
}

export const CapitalizeFirstLetter = (s: string): string => s.charAt(0).toUpperCase() + s.slice(1);

export function IsNumeric(n: any) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

export const FormatNumber = (n: number): string => {
    const fractionDigits: number = Trad.PrecisioneImporto();

    return new Intl.NumberFormat(Trad.FormatoLingua(), {
        currency: Trad.FormatoImporto(),
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).format(n);
};

export function AddMetronicStyles(id: string, href: string) {
    if (!document.getElementById(id)) {
        const head = document.getElementsByTagName("head")[0];
        const link = document.createElement("link");

        link.id = id;
        link.rel = "stylesheet";
        link.type = "text/css";
        link.href = href;
        link.media = "all";
        head.appendChild(link);
    }
}

//Da usare con JSON.parse
export function DateReviver(key: any, value: any): any {
    if (typeof value === "string") {
        const RE = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
        if (RE) {
            return new Date(Date.UTC(+RE[1], +RE[2] - 1, +RE[3], +RE[4], +RE[5], +RE[6]));
        }
    }
    return value;
}

export function ColoreRandom(): string {
    const colore: string = "rgb(" + Math.floor(Math.random() * 256) + "," + Math.floor(Math.random() * 256) + "," + Math.floor(Math.random() * 256) + ")";
    return colore;
}

export function ColoreStatic(i: number): string {
    const Colori: string[] = [
        "rgb(255, 184, 34)",
        "rgb(65, 137, 199)",
        "rgb(52, 191, 163)",
        "rgb(244, 81, 108)",
        "rgb(176,176,176)",
        "rgb(255,226,166)",
        "rgb(217, 231, 243)",
        "rgb(194,235,227)",
        "rgb(250,185,196)",
        "rgb(223,223,223)",
        "rgb(255,249,237)",
        "rgb(239,245,250)",
        "rgb(248,253,252)",
        "rgb(254,248,249)",
        "rgb(238,238,238)",
        "rgb(127,92,17)",
        "rgb(32,68,99)",
        "rgb(26,95,81)",
        "rgb(122,40,54)",
        "rgb(88,88,88)"
    ];
    return Colori[i % Colori.length];
}

export function ColoreStaticA(i: number, rgba = 0.8): string {
    let colore: string = ColoreStatic(i);
    colore = colore.replace("rgb", "rgba");
    return `${colore.substr(0, colore.length - 1)}, ${rgba})`;
}

let AvviatoModale = false;

export function InfoModale(titolo: string, testo: string, tipo?: string, azioneChiusura?: () => any) {
    Log(LogCat.InfoModale, true, testo, titolo);

    let tipoInfo = "alert-info";
    if (tipo != undefined) {
        switch (tipo) {
            case "success":
                tipoInfo = "alert-success";
                break;
            case "notice":
                tipoInfo = "alert-info";
                break;
            case "warning":
                tipoInfo = "alert-warning";
                break;
            case "error":
                tipoInfo = "alert-danger";
                break;
        }
    }

    if (!AvviatoModale) {
        //if ($('#modaleMessInfo').attr("aria-hidden") == "true") {

        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt != undefined) {
                let isEscape = false;
                if ("key" in evt) {
                    isEscape = evt.key === "Escape" || evt.key === "Esc";
                } else {
                    isEscape = (evt as KeyboardEvent).keyCode === 27;
                }
                if (isEscape) {
                    AvviatoModale = false;
                    if (azioneChiusura != undefined) {
                        azioneChiusura();
                    }
                }
            }
        };

        AvviatoModale = true;
        $("#modaleMessTesto").focus();
        $("#modalMessTestata").attr("class", "modal-header " + tipoInfo);
        $("#modaleMessTitolo").text(titolo);
        $("#modaleMessTesto").html("").append(testo);
        $("#btnModaleMessInfoClose").text(Trad.Trad("Chiudi"));
        $("#btnModaleMessInfo").click();
        $("#modaleMessInfo").on("hidden.bs.modal", function (e) {
            AvviatoModale = false;
            if (azioneChiusura != undefined) {
                azioneChiusura();
            }
        });
        $("#btnModaleMessInfoClose").click(function () {
            AvviatoModale = false;
            if (azioneChiusura != undefined) {
                azioneChiusura();
            }
        });
    }
}

export function InfoModaleSuccess(titolo: string, testo: any, azioneChiusura?: () => any) {
    InfoModale(titolo, testo, "success", azioneChiusura);
}

export function InfoModaleNotice(titolo: string, testo: any, azioneChiusura?: () => any) {
    InfoModale(titolo, testo, "notice", azioneChiusura);
}

export function InfoModaleWarning(titolo: string, testo: any, azioneChiusura?: () => any) {
    InfoModale(titolo, testo, "warning", azioneChiusura);
}

export function InfoModaleError(titolo: string, testo: any, azioneChiusura?: () => any) {
    InfoModale(titolo, testo, "error", azioneChiusura);
}

export function AvviaCaricamento(titolo?: string) {
    //if ($('#modaleLoading').attr("aria-hidden")) {
    //    $('#modaleLoadingTitolo').text(Trad.Trad(titolo != undefined ? titolo : "Caricamento..."));
    //    $('#btnModaleLoading').click();
    //}
}

export function FermaCaricamento() {
    //setTimeout($('#btnModaleLoading').click(), 5000);
}

export function Sleep(milliseconds: number) {
    const start = new Date().getTime();
    for (let i = 0; i < 1e7; i++) {
        if (new Date().getTime() - start > milliseconds) {
            break;
        }
    }
}

export function DeserializzaOggetto(oggetto: any, json: DatiJSON): any {
    const OggettoDeseriallizzato = JSON.parse(json);
    for (const P in OggettoDeseriallizzato) {
        oggetto[P] = OggettoDeseriallizzato[P];
    }
    return oggetto;
}

export function DeserializzaOggettoNuovo<T>(c: { new(): T }, json: DatiJSON): T {
    const R: T = new c();
    const OggettoDeseriallizzato = JSON.parse(json);
    for (const P in OggettoDeseriallizzato) {
        (R as any)[P] = OggettoDeseriallizzato[P];
    }
    return R;
}

export type Funzioni =
    | "Admin"
    | "AdminPermessi"
    | "AnagController"
    | "AssociaPolizzaAPOS"
    | "BinderController"
    | "BinderProdottoGaranzia"
    | "BinderProdottoGaranziaController"
    | "BinderProductFileAsync"
    | "CapogruppoAnag"
    | "CartaServizi"
    | "CreazioneAffidamentoDaCompagniaACoverholderOBroker"
    | "DatiEconomiciController"
    | "DatiEconomiciEstraiDati"
    | "DerogaController"
    | "DocumentController"
    | "FatturaDatiEconomiciController"
    | "FideAffidamentoApprovazioneCommenti"
    | "FideAffidamentoController"
    | "FideAffidamentoDatiPOS"
    | "FideAffidamentoID_AnagDa"
    | "FideCoobbligatoController"
    | "FideTassiController"
    | "FideValutazioneController"
    | "FileController"
    | "ForzaturaEmissionePolizzaPosticipataAnticipata"
    | "GruppoController"
    | "Logout"
    | "PolizzaApprovazioneCommenti"
    | "PolizzaController"
    | "PolizzaFideiussioni"
    | "PolizzaRCP"
    | "ProprioUtente"
    | "ProvvigioneController"
    | "QuietanzaController"
    | "RCPComparatoreController"
    | "RegoleController"
    | "TipiController"
    | "UtentiController"
    | "CodiceControlloVisualizza"
    | "NewsController"
    | "DocumentsListController"
    | "EstrattoContoController"
    | "ForzaInteresseLegale";

//Scrittura - Valore di autorizzazione in scrittura
export const Scrittura = 2;
//Lettura - Valore di autorizzazione in lettura
export const Lettura = 1;
export type Azioni = 0 | 1 | 2;

export function AzioneAbilitata(funzione: Funzioni, azione: Azioni): boolean {
    const Sessione = GetSessione();
    if (Sessione == undefined || Sessione.Autorizzazioni == undefined) return true;
    //Situazione anomala, si presente durante il refresh della pagina con WebPack attivo
    else {
        if (Sessione.Autorizzazioni[funzione] != undefined && Sessione.Autorizzazioni[funzione] >= azione) {
            Log(LogCat.Azioni, false, "Azione abilitata", funzione, azione, Sessione.Autorizzazioni[funzione]);
            return true;
        } else {
            Log(LogCat.Azioni, true, "Azione non abilitata", funzione, azione, Sessione.Autorizzazioni[funzione]);
            return false;
        }
    }
}

export function RestituisciIcona(tipo: string) {
    switch (tipo) {
        case "application/pdf":
            return "fa fa-file-pdf";
        case "application/vnd.ms-word":
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return "fa fa-file-word";
        case "application/vnd.ms-excel":
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
            return "fa fa-file-excel";
        case "image/jpeg":
        case "image/jpg":
        case "image/gif":
        case "image/png":
            return "fa fa-file-image";
        case "text/plain":
            return "fa fa-file-alt";
        case "application/x-zip-compressed":
            return "fa fa-file-archive";
        case "application/pkcs7":
            return "fa fa-certificate";
        default:
            return "fa fa-file";
    }
}

export function ValoreDiDefault(tipo: number): any {
    switch (tipo) {
        case 1: //Intero
            return 0;
        case 2: //Stringa
            return '""';
        case 5: //Boolean
            return false;
        case 9: //Importo
            return 0.0;
        case 7: //Tipo
            return 0;
        case 10: //Percentuale
            return 0;
        case 3: //Data
            return '"' + moment().format() + '"';
        default:
            return '""';
    }
}

export function CreaClassePolizzaCar(dati: { [I: string]: Dati.CInfoCampo }): any {
    let classe = "";
    for (const I in dati) {
        classe += '"' + dati[I].Campo + '":' + ValoreDiDefault(dati[I].ID_TipoCampo) + ", ";
    }

    classe += '"ATI": false, "EtichettaATI": "", "MandantiJSON": "{}", ';

    classe = "{" + classe.substr(0, classe.length - 2) + "}";
    return JSON.parse(classe);
}

export function CreaClassePolizzaFide(dati: { [I: string]: Dati.CInfoCampo }): any {
    let classe = "";
    for (const I in dati) {
        classe += '"' + dati[I].Campo + '":' + ValoreDiDefault(dati[I].ID_TipoCampo) + ", ";
    }

    classe += '"ATI": false, "EtichettaATI": "", "MandantiJSON": "{}", ';

    classe = "{" + classe.substr(0, classe.length - 2) + "}";
    return JSON.parse(classe);
}

export function CreaClassePolizzaRCP(dati: { [I: string]: Dati.CInfoCampo }): any {
    let classe = "";
    for (const I in dati) {
        classe += '"' + dati[I].Campo + '":' + ValoreDiDefault(dati[I].ID_TipoCampo) + ", ";
    }

    classe = "{" + classe.substr(0, classe.length - 2) + "}";
    return JSON.parse(classe);
}

export function DimensioneCSS(dimensione: number): string {
    switch (dimensione) {
        case 1: {
            return "col-12 col-sm-12 col-md-1 col-lg-1 col-lx-1";
        }
        case 2: {
            return "col-12 col-sm-12 col-md-2 col-lg-2 col-lx-2";
        }
        case 3: {
            return "col-12 col-sm-12 col-md-3 col-lg-3 col-lx-3";
        }
        case 4: {
            return "col-12 col-sm-12 col-md-4 col-lg-4 col-lx-4";
        }
        case 5: {
            return "col-12 col-sm-12 col-md-5 col-lg-5 col-lx-5";
        }
        case 6: {
            return "col-12 col-sm-12 col-md-6 col-lg-6 col-lx-6";
        }
        case 7: {
            return "col-12 col-sm-12 col-md-7 col-lg-7 col-lx-7";
        }
        case 8: {
            return "col-12 col-sm-12 col-md-8 col-lg-8 col-lx-8";
        }
        case 9: {
            return "col-12 col-sm-12 col-md-9 col-lg-9 col-lx-9";
        }
        case 10: {
            return "col-12 col-sm-12 col-md-10 col-lg-10 col-lx-10";
        }
        case 11: {
            return "col-12 col-sm-12 col-md-11 col-lg-11 col-lx-11";
        }
        default: {
            return "col-12 col-sm-12 col-md-12 col-lg-12 col-lx-12";
        }
    }
}

export function GetComponente(
    qualificatore: string,
    struttura: Dati.CCampoStruttura,
    dato: Dati.CCampoDato,
    onAggiorna: (e: React.FormEvent<any> | string, valore: any) => any,
    DatiQuestionario?: Dati.CDictionary<any>
): any {
    if (struttura != undefined && dato != undefined) {
        const identificativo: string = struttura.Campo + "_" + qualificatore;
        switch (struttura.ID_TipoCampo) {
            case 1: //Intero
                return (
                    <InputNumero
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore != undefined ? dato.Valore : 0}
                        Etichetta={struttura.Etichetta}
                        OnChange={onAggiorna}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                        Precisione={0}
                    />
                );
            case 2: //Stringa
                return (
                    <InputStringa
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={struttura.Etichetta}
                        OnChange={e => {
                            onAggiorna(identificativo, (e as React.FormEvent<any>).currentTarget.value);
                        }}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                    />
                );
            case 11: //Testo
                return (
                    <InputTesto
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={struttura.Etichetta}
                        OnChange={e => {
                            onAggiorna(identificativo, (e as React.FormEvent<any>).currentTarget.value);
                        }}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                    />
                );
            case 9: //Importo
                return (
                    <InputImporto
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={Trad.Trad(struttura.Etichetta)}
                        OnChange={onAggiorna}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                    />
                );
            case 10: //Percentuale
                return (
                    <InputPercentuale
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={Trad.Trad(struttura.Etichetta)}
                        OnChange={onAggiorna}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                    />
                );
            case 3: //Data
                return (
                    <InputData
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore || undefined}
                        Etichetta={struttura.Etichetta}
                        OnChange={onAggiorna}
                        DataMinima={struttura.Parametri && struttura.Parametri["DataMinima"] ? new Date(struttura.Parametri["DataMinima"]) : undefined}
                        DataMassima={struttura.Parametri && struttura.Parametri["DataMassima"] ? new Date(struttura.Parametri["DataMassima"]) : undefined}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                    />
                );
            case 5: //Checkbox
                return (
                    <InputCheckBox
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={Trad.Trad(struttura.Etichetta)}
                        OnChange={e => onAggiorna(e as React.FormEvent<any>, undefined)}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                    />
                );
            case 16: //CAP
                return (
                    <InputCAP
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={Trad.Trad(struttura.Etichetta)}
                        OnChange={onAggiorna}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                        Provincia={DatiQuestionario != undefined ? DatiQuestionario.Item(struttura.Parametri["Provincia"]) : ""}
                        Comune={DatiQuestionario != undefined ? DatiQuestionario.Item(struttura.Parametri["Comune"]) : ""}
                    />
                );
            case 17: //Comune
                return (
                    <InputComune
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={Trad.Trad(struttura.Etichetta)}
                        OnChange={onAggiorna}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                        Provincia={DatiQuestionario != undefined ? DatiQuestionario.Item(struttura.Parametri["Provincia"]) : ""}
                        CAP={DatiQuestionario != undefined ? DatiQuestionario.Item(struttura.Parametri["CAP"]) : ""}
                    />
                );
            case 18: //Provincia
                return (
                    <InputProvincia
                        key={struttura.Campo + "_" + qualificatore}
                        Name={identificativo}
                        Id={struttura.Campo + "_" + qualificatore}
                        Valore={dato.Valore}
                        Etichetta={Trad.Trad(struttura.Etichetta)}
                        OnChange={onAggiorna}
                        CSS={DimensioneCSS(struttura.DimensioneGrafica)}
                        CAP={DatiQuestionario != undefined ? DatiQuestionario.Item(struttura.Parametri["CAP"]) : ""}
                        Comune={DatiQuestionario != undefined ? DatiQuestionario.Item(struttura.Parametri["Comune"]) : ""}
                    />
                );
            default:
                return struttura.Campo + " [" + struttura.ID_TipoCampo + "]";
        }
    } else {
        return false;
    }
}

export function GetColorForPercentage(pct: number, index: number, value: number, pctRed?: number, pctYellow?: number, pctGreen?: number): any {
    const percentColors = [
        { pct: 0.0, color: { r: 0xff, g: 0x00, b: 0 } },
        { pct: 0.5, color: { r: 0xff, g: 0xff, b: 0 } },
        { pct: 1.0, color: { r: 0x00, g: 0xff, b: 0 } }
    ];

    if (pctRed != undefined) {
        percentColors[0] = { pct: pctRed, color: { r: 0xff, g: 0x00, b: 0 } };
    }

    if (pctYellow != undefined) {
        percentColors[1] = {
            pct: pctYellow,
            color: { r: 0xff, g: 0xff, b: 0 }
        };
    }

    if (pctGreen != undefined) {
        percentColors[2] = { pct: pctGreen, color: { r: 0x00, g: 0xff, b: 0 } };
    }

    if (index > value) return "rgb(235, 237, 242)";

    let i = 1;
    for (i = 1; i < percentColors.length - 1; i++) {
        if (pct < percentColors[i].pct) {
            break;
        }
    }
    const lower = percentColors[i - 1];
    const upper = percentColors[i];
    const range = upper.pct - lower.pct;
    const rangePct = (pct - lower.pct) / range;
    const pctLower = 1 - rangePct;
    const pctUpper = rangePct;
    const color = {
        r: Math.floor(lower.color.r * pctLower + upper.color.r * pctUpper),
        g: Math.floor(lower.color.g * pctLower + upper.color.g * pctUpper),
        b: Math.floor(lower.color.b * pctLower + upper.color.b * pctUpper)
    };
    return "rgb(" + [color.r, color.g, color.b].join(",") + ")";
    // or output as hex if preferred
}

///<summary>TipiRamo - Fideiussioni/summary>
export const TipiRami_Fideiussioni = 1;
export const TipoProdotto_CauzioneProvvisoriaLavori = 4;
export const TipoProdotto_CauzioneProvvisoriaServizi = 17;
export const TipoProdotto_CauzioneProvvisoriaForniture = 18;
export const TipoProdotto_ERinn = 61;
///<summary>TipiRamo - RCP/summary>
export const TipiRami_RCP = 2;
///<summary>TipiRamo - CAR/summary>
export const TipiRami_CAR = 3;
///<summary>TipiRamo - Infortuni/summary>
export const TipiRami_Infortuni = 4;
///<summary>TipiRamo - Enti/summary>
export const TipiRami_Enti = 5;
///<summary>TipiRamo - Property/summary>
export const TipiRami_Property = 6;


/****************************** DATI BASE PER LA STAMPA INIZIO ******************************/
//export const StampaURL: string = "http://localhost:51751/StampaAR.aspx";
//export const StampaURL: string = "http://stampa.allrisks.it/StampaAR.aspx";

export function StampaURL(): string {
    const forzaRisultato = ""; //DA IMPOSTARE SOLO PER DEBUG PARTICOLARI
    //const forzaRisultato = "http://localhost:51751/StampaAR.aspx";

    if (forzaRisultato != "") return forzaRisultato;

    if (window.location.origin == "http://localhost:27860" 
        || window.location.origin == "http://localhost:3000"
        || window.location.origin == "https://localhost:3000"
        || window.location.origin == "http://localhost:4000"
        || window.location.origin == "https://localhost:4000")
    return "https://stampa.allrisks.it/StampaAR.aspx";
    else return "https://stampa.allrisks.it/StampaAR.aspx";
}

export function StampaDatabase(): string {
    const forzaRisultato = ""; //DA IMPOSTARE SOLO PER DEBUG PARTICOLARI
    //let forzaRisultato: string = "MYAR";

    if (forzaRisultato !== "") return forzaRisultato;

    switch (window.location.origin) {
        case "https://myar-dev.azurewebsites.net":
        case "http://inar-dev-master.allrisks.it":
        case "http://inar-dev-master.allrisks.it:27864":
        case "http://inar-dev2.allrisks.it":
        case "http://inar-dev2.allrisks.it:27865":
            return "MYARDEV";

        case "http://inar-dev.allrisks.it":
        case "http://inar-dev.allrisks.it:27863":
        case "http://inar-dev2.allrisks.it":
        case "http://inar-dev2.allrisks.it:27865":
        case "https://dev.inar.allrisks.it":
        case "http://localhost:3000":
        case "http://localhost:4000":
        case "https://localhost:3000":
        case "https://localhost:4000":
            return "INARTEST";

        case "https://test.inar.allrisks.it":
            return "INARTEST";

        case "https://inar2.allrisks.it":
            return "INAR2";

        case "https://myar-rqdemo.azurewebsites.net":
        case "http://inar-demo.allrisks.it":
            return "RQDEMO";

        case "https://myar.azurewebsites.net":
        case "https://inar.allrisks.it":
        case "https://inar2.allrisks.it":
        case "https://www.inar.allrisks.it":
            return "MYAR";

        case "http://inar-ieri.allrisks.it":
            return "INARIERI";

        case "http://localhost:27860":
            return "SVIL";

        case "http://inar-locale.techs.srl":
            return "INARLOCALE";

        default:
            return "DA INIZIALIZZARE";
    }
}

export function StampaDatabaseEstrattoConto(): string {
    const forzaRisultato = ""; //DA IMPOSTARE SOLO PER DEBUG PARTICOLARI
    //let forzaRisultato: string = "MYAR";

    if (forzaRisultato != "") return forzaRisultato;

    switch (window.location.origin) {
        case "https://myar-dev.azurewebsites.net":
        case "http://inar-dev.allrisks.it":
        case "http://inar-dev.allrisks.it:27863":
        case "http://inar-dev-master.allrisks.it":
        case "http://inar-dev-master.allrisks.it:27864":
        case "http://inar-dev2.allrisks.it":
        case "http://inar-dev2.allrisks.it:27865":
            return "MYARDEVEC";

        case "https://myar-rqdemo.azurewebsites.net":
        case "https://inar-demo.allrisks.it":
            return "RQDEMOEC";

        case "https://myar.azurewebsites.net":
        case "https://inar.allrisks.it":
        case "https://www.inar.allrisks.it":
            return "MYAREC";

        case "https://inar-ieri.allrisks.it":
            return "INARIERIEC";

        case "http://localhost:27860":
        case "http://localhost:3000":
            return "SVILEC";

        case "http://inar-locale.techs.srl":
            return "INARLOCALEEC";

        default:
            return "DA INIZIALIZZARE (EC)";
    }
}

/******************************* DATI BASE PER LA STAMPA FINE *******************************/

//export class CReactEvent implements React.FormEvent<any> {
//    bubbles: boolean = false;
//    cancelable: boolean = false;
//    currentTarget: EventTarget = new EventTarget;
//    defaultPrevented: boolean = false;
//    eventPhase: number = 0;
//    isTrusted: boolean = false;
//    nativeEvent: Event = new Event("", undefined);
//    target: EventTarget = new EventTarget;
//    timeStamp: number = 0;
//    type: string = "";
//    preventDefault() { };
//    isDefaultPrevented(): boolean { return false; };
//    stopPropagation(): void { };
//    isPropagationStopped(): boolean { return false; };
//    persist(): void { };
//}

export const PremioMigliore = 1;
export const PremioStandard = 0;
export const PremioPeggiore = -1;

/* REGEX */
//Controllo del codice fiscale
export const REGEX_CF = "[A-Z0-9]{16}"; //"/^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i";
//Controllo della partita iva
export const REGEX_PIVA = "^(IT){0,1}[0-9]{11}$";
export function REGEXPerControlloPIVA(id_TipoAnagPrincipale: string, lunghezza: number) {
    switch (id_TipoAnagPrincipale) {
        case Tipi_TAP_ATI:
            if (lunghezza == 16) {
                return REGEX_CF;
            } else {
                return REGEX_PIVA;
            }
        case Tipi_TAP_Beneficiario:
            if (lunghezza == 16) {
                return REGEX_CF;
            } else {
                return REGEX_PIVA;
            }
        case Tipi_TAP_PersonaGiuridica:
            return REGEX_PIVA;
        case Tipi_TAP_DittaIndividuale:
        case Tipi_TAP_PersonaFisica:
            return REGEX_CF;
        default:
            return REGEX_CF;
    }
}
export function ValidationPerControlloPIVA(id_TipoAnagPrincipale: string, lunghezza: number) {
    switch (id_TipoAnagPrincipale) {
        case Tipi_TAP_ATI:
            if (lunghezza == 16) {
                return "FiscalCode";
            } else {
                return "VatNumber";
            }
        case Tipi_TAP_Beneficiario:
            if (lunghezza == 16) {
                return "FiscalCode";
            } else {
                return "VatNumber";
            }
        case Tipi_TAP_PersonaGiuridica:
            return "VatNumber";
        case Tipi_TAP_DittaIndividuale:
        case Tipi_TAP_PersonaFisica:
            return "FiscalCode";
        default:
            return "FiscalCode";
    }
}

//http://www.icosaedro.it/cf-pi/vedi-codice.cgi?f=pi-js.txt
export function ControllaPIVA(partitaIVA: string): boolean {
    if (partitaIVA == "") return false;

    if (!/^[0-9]{11}$/.test(partitaIVA)) return false;

    let s = 0;
    for (let i = 0; i <= 9; i += 2) s += partitaIVA.charCodeAt(i) - "0".charCodeAt(0);
    for (let i = 1; i <= 9; i += 2) {
        let c = 2 * (partitaIVA.charCodeAt(i) - "0".charCodeAt(0));
        if (c > 9) c = c - 9;
        s += c;
    }
    const atteso = (10 - (s % 10)) % 10;
    if (atteso != partitaIVA.charCodeAt(10) - "0".charCodeAt(0)) return false;

    return true;
}

///<summary>AnagStato - In completamento</summary>
export const Tipi_AS_InAcquisizione: string = "AS-InAcquisizione";
///<summary>AnagStato - Completo</summary>
export const Tipi_AS_Attivo: string = "AS-Attivo";
///<summary>AppendiceStato - Preventivo di appendice</summary>
export const Tipi_APS_Preventivo: string = "APS-Preventivo";
///<summary>AppendiceStato - Appendice rifiutata</summary>
export const Tipi_APS_Rifiutata: string = "APS-Rifiutata";
///<summary>AppendiceStato - Appendice approvata</summary>
export const Tipi_APS_Emessa: string = "APS-Emessa";
///<summary>AppendiceTipo - Appendice di annullamento</summary>
export const Tipi_AT_Annullamento: string = "AT-Annullamento";
///<summary>AppendiceTipo - Appendice di precisazioni condizioni contrattuali</summary>
export const Tipi_AT_PrecisazioniCondizioniContrattuali: string = "AT-PrecisazioniCondizioniContrattuali";
///<summary>AppendiceTipo - Appendice di proroga</summary>
export const Tipi_AT_Proroga: string = "AT-Proroga";
///<summary>AppendiceTipo - Preventivo di appendice di proroga</summary>
export const Tipi_AT_PreventivoProroga: string = "AT_PreventivoProroga";
///<summary>AppendiceTipo - Appendice di svincolo</summary>
export const Tipi_AT_Svincolo: string = "AT-Svincolo";
///<summary>AppendiceTipo - Appendice di variazione Rischio</summary>
export const Tipi_AT_VariazioneRischio: string = "AT-VariazioneRischio";
///<summary>BinderStato - Binder non ancora stipulato</summary>
export const Tipi_BS_Inserito: string = "BS-Inserito";
///<summary>BinderStato - Binder stipulato</summary>
export const Tipi_BS_Stipulato: string = "BS-Stipulato";
///<summary>CambioStato - Cambi stati per le anagrafiche</summary>
export const Tipi_AnagStato: string = "AnagStato";
///<summary>CambioStato - Cambi stati per binder</summary>
export const Tipi_BinderStato: string = "BinderStato";
///<summary>CambioStato - Cambi stati per le deroghe</summary>
export const Tipi_DerogaStato: string = "DerogaStato";
///<summary>CambioStato - CambiStatiPerFideAffidamentoApprovazione</summary>
export const Tipi_FideAffidamentoApprovazione: string = "FideAffidamentoApprovazione";
///<summary>CambioStato - Cambi stati per gli affidamenti</summary>
export const Tipi_FideAffidamentoEsito: string = "FideAffidamentoEsito";
///<summary>CambioStato - Cambi stati per le valutazioni</summary>
export const Tipi_FideValutazioneEsito: string = "FideValutazioneEsito";
///<summary>CambioStato - CambiStatiPerPolizzaApprovazione</summary>
export const Tipi_PolizzaApprovazione: string = "PolizzaApprovazione";
///<summary>CambioStato - Cambi stati per le polizze</summary>
export const Tipi_PolizzaStato: string = "PolizzaStato";
///<summary>CambioStatoAzione - Funzione che aggiorna i dati su altre tabelle</summary>
export const Tipi_CSA_Aggiorna: string = "CSA-Aggiorna";
///<summary>CambioStatoAzione - Funzione che blocca il cambio stato</summary>
export const Tipi_CSA_Blocco: string = "CSA-Blocco";
///<summary>CambioStatoAzione - Funzione che controlla dipendenze con altre tabelle</summary>
export const Tipi_CSA_Dipendenza: string = "CSA-Dipendenza";
///<summary>CambioStatoPercorso - Affidamento che deve essere approvato dalla compagnia</summary>
export const Tipi_CSP_FideAffidamentoApprovaCompagnia: string = "CSP-FideAffidamentoApprovaCompagnia";
///<summary>CambioStatoPercorso - Affidamento che deve essere approvato solo dal coverholder</summary>
export const Tipi_CSP_FideAffidamentoApprovaCoverholder: string = "CSP-FideAffidamentoApprovaCoverholder";
///<summary>DerogaStato - Approvata</summary>
export const Tipi_DR_Approvata: string = "DR-Approvata";
///<summary>DerogaStato - Da approvare</summary>
export const Tipi_DR_DaApprovare: string = "DR-DaApprovare";
///<summary>DerogaStato - Level up della richiesta di deroga</summary>
export const Tipi_DR_Passa: string = "DR-Passa";
///<summary>DerogaStato - Rifiutata</summary>
export const Tipi_DR_Rifiutata: string = "DR-Rifiutata";
///<summary>Polizza - Polizza CAR</summary>
export const Tipi_DT_CAR: string = "DT-CAR";
///<summary>DerogaTipo - Deroga fideiussione</summary>
export const Tipi_DT_Fideiussione: string = "DT-Fideiussione";
///<summary>Polizza - Polizza</summary>
export const Tipi_DT_Polizza: string = "DT-Polizza";
///<summary>PolizzaNeutra - Neutra polizza</summary>
export const Tipi_DT_PolizzaNeutra: string = "DT-PolizzaNeutra";
///<summary>FideAffidamento - Affidamento</summary>
export const Tipi_FA_Affidamento: string = "FA-Affidamento";
///<summary>FideAffidamento - Affidamento per fideiussioni non provvisorie</summary>
export const Tipi_FA_NonProvvisorie: string = "FA-NonProvvisorie";
///<summary>FideAffidamento - Affidamento per fideiussioni provvisorie</summary>
export const Tipi_FA_Provvisorie: string = "FA-Provvisorie";
///<summary>FideAffidamentoApprovazione - Sottoposto a sottoscrizione</summary>
export const Tipi_FAA_Proposta: string = "FAA-Proposta";
///<summary>FideAffidamentoApprovazione - Approvato con parere positivo</summary>
export const Tipi_FAA_ValutazionePositiva: string = "FAA-ValutazionePositiva";
///<summary>FideAffidamentoApprovazione - Approvato con parere negativo</summary>
export const Tipi_FAA_ValutazioneNegativa: string = "FAA-ValutazioneNegativa";
///<summary>FideAffidamentoApprovazione - Sottoscrizione affidamento</summary>
export const Tipi_FAA_ApprovatoPositivo: string = "FAA-ApprovatoPositivo";
///<summary>FideAffidamentoApprovazione - Rifiuto affidamento</summary>
export const Tipi_FAA_ApprovatoNegativo: string = "FAA-ApprovatoNegativo";
///<summary>FideAffidamentoEsito - Creazione affidamento</summary>
export const Tipi_FAE_CreazioneAffidamento: string = "FAE-CreazioneAffidamento";
///<summary>FideAffidamentoEsito - Proposta affidamento</summary>
export const Tipi_FAE_Proposta: string = "FAE-Proposta";
///<summary>FideAffidamentoEsito - Sottoposto a sottoscrizione</summary>
export const Tipi_FAE_Sottoposto: string = "FAE-Sottoposto";
///<summary>FideAffidamentoEsito - Approvato con parere positivo</summary>
export const Tipi_FAE_ApprovatoPositivo: string = "FAE-ApprovatoPositivo";
///<summary>FideAffidamentoEsito - Approvato con parere negativo</summary>
export const Tipi_FAE_ApprovatoNegativo: string = "FAE-ApprovatoNegativo";
///<summary>FideAffidamentoEsito - Sospensione affidamento</summary>
export const Tipi_FAE_Sospensione: string = "FAE-Sospensione";
///<summary>FideAffidamentoEsito - Sottoscrizione affidamento</summary>
export const Tipi_FAE_Sottoscritto: string = "FAE-Sottoscritto";
///<summary>FideAffidamentoEsito - Rifiuto affidamento</summary>
export const Tipi_FAE_Rifiuto: string = "FAE-Rifiuto";
///<summary>FideAffidamentoEsito - Proposta riapertura affidamento</summary>
export const Tipi_FAE_PropostaRiapertura: string = "FAE-PropostaRiapertura";
///<summary>FideAffidamentoEsito - Revisione affidamento</summary>
export const Tipi_FAE_Revisione: string = "FAE-Revisione";
///<summary>FideAffidamentoEsito - Rinnovo affidamento</summary>
export const Tipi_FAE_Rinnovo: string = "FAE-Rinnovo";
///<summary>FideAffidamentoEsito - Affidamento morto</summary>
export const Tipi_FAE_Morto: string = "FAE-Morto";
///<summary>FideValutazioneEsito - Accettata</summary>
export const Tipi_VA_Accettata: string = "VA-Accettata";
///<summary>FideValutazioneEsito - In valutazione</summary>
export const Tipi_VA_InValutazione: string = "VA-InValutazione";
///<summary>FideValutazioneEsito - Rifiutata</summary>
export const Tipi_VA_Rifiutata: string = "VA-Rifiutata";
///<summary>File - 730</summary>
export const Tipi_F_730: string = "F-730";
///<summary>File - Altro</summary>
export const Tipi_F_Altro: string = "F-Altro";
///<summary>File - Appendice</summary>
export const Tipi_F_Appendice: string = "F-Appendice";
///<summary>File - Appendice Binder</summary>
export const Tipi_F_AppendiceBinder: string = "F-AppendiceBinder";
///<summary>File - Atto Costitutivo</summary>
export const Tipi_F_AttoCostitutivo: string = "F-AttoCostitutivo";
///<summary>File - Autorizzazione</summary>
export const Tipi_F_Autorizzazione: string = "F-Autorizzazione";
///<summary>File - Bando Gara</summary>
export const Tipi_F_BandoGara: string = "F-BandoGara";
///<summary>File - Bilancio</summary>
export const Tipi_F_Bilancio: string = "F-Bilancio";
///<summary>File - Business Plan</summary>
export const Tipi_F_BusinessPlan: string = "F-BusinessPlan";
///<summary>File - Carta d'Identità</summary>
export const Tipi_F_CartaIdentita: string = "F-CartaIdentita";
///<summary>File - Certificato SAL</summary>
export const Tipi_F_CertificatoSal: string = "F-CertificatoSal";
///<summary>File - Certificazione Ambientale</summary>
export const Tipi_F_CertificazioneAmbientale: string = "F-CertificazioneAmbientale";
///<summary>File - Classe Appartenenza Rifiuti</summary>
export const Tipi_F_ClasseAppartenenzaRifiuti: string = "F-ClasseAppartenenzaRifiuti";
///<summary>File - Collaudo</summary>
export const Tipi_F_Collaudo: string = "F-Collaudo";
///<summary>File - Contratto Aggiudicazione</summary>
export const Tipi_F_ContrattoAggiudicazione: string = "F-ContrattoAggiudicazione";
///<summary>File - Contratto Binder</summary>
export const Tipi_F_ContrattoBinder: string = "F-ContrattoBinder";
///<summary>File - Contratto Oggetto</summary>
export const Tipi_F_ContrattoOggetto: string = "F-ContrattoOggetto";
///<summary>File - Contratto Preliminare Vendita</summary>
export const Tipi_F_ContrattoPreliminareVendita: string = "F-ContrattoPreliminareVendita";
///<summary>File - Convenzione</summary>
export const Tipi_F_Convenzione: string = "F-Convenzione";
///<summary>File - Coobbligazioni</summary>
export const Tipi_F_Coobbligazioni: string = "F-Coobbligazioni";
///<summary>File - Copia Agenzia</summary>
export const Tipi_F_CopiaAgenzia: string = "F-CopiaAgenzia";
///<summary>File - Disciplinare di gara</summary>
export const Tipi_F_DisciplinareGara: string = "F-DisciplinareGara";
///<summary>File - Documenti disdette</summary>
export const Tipi_F_Disdette: string = "F-Disdette";
///<summary>File - Documento</summary>
export const Tipi_F_Documento: string = "F-Documento";
///<summary>File - Documento Svincolo</summary>
export const Tipi_F_DocumentoSvincolo: string = "F-DocumentoSvincolo";
///<summary>File - DURC</summary>
export const Tipi_F_DURC: string = "F-DURC";
///<summary>File - Fattura</summary>
export const Tipi_F_Fattura: string = "F-Fattura";
///<summary>File - ISO 14001</summary>
export const Tipi_F_ISO14001: string = "F-ISO14001";
///<summary>File - ISO 14067</summary>
export const Tipi_F_ISO14067: string = "F-ISO14067";
///<summary>File - ISO 18001</summary>
export const Tipi_F_ISO18001: string = "F-ISO18001";
///<summary>File - ISO 9000</summary>
export const Tipi_F_ISO9000: string = "F-ISO9000";
///<summary>File - Modello IVA</summary>
export const Tipi_F_ModelloIVA: string = "F-ModelloIVA";
///<summary>File - Mutuo</summary>
export const Tipi_F_Mutuo: string = "F-Mutuo";
///<summary>File - Passaporto</summary>
export const Tipi_F_Passaporto: string = "F-Passaporto";
///<summary>File - Patente</summary>
export const Tipi_F_Patente: string = "F-Patente";
///<summary>File - Permesso di costruire</summary>
export const Tipi_F_PermessoCostruire: string = "F-PermessoCostruire";
///<summary>File - Polizza firmata</summary>
export const Tipi_F_Polizza: string = "F-Polizza";
///<summary>File - Privacy</summary>
export const Tipi_F_Privacy: string = "F-Privacy";
///<summary>File - Progetto Contributo</summary>
export const Tipi_F_ProgettoContributo: string = "F-ProgettoContributo";
///<summary>File - Rendicontazione</summary>
export const Tipi_F_Rendicontazione: string = "F-Rendicontazione";
///<summary>File - Report fattura servizio recupero dati economici</summary>
export const Tipi_F_ReportFatturaDatiEconomici: string = "F-ReportFatturaDatiEconomici";
///<summary>File - Ricevuta Pagamento</summary>
export const Tipi_F_RicevutaPagamento: string = "F-RicevutaPagamento";
///<summary>File - S.A.L</summary>
export const Tipi_F_SAL: string = "F-SAL";
///<summary>File - Schema Fideiussione</summary>
export const Tipi_F_SchemaFide: string = "F-SchemaFide";
///<summary>File - Documenti sinistri</summary>
export const Tipi_F_Sinistri: string = "F-Sinistri";
///<summary>File - SOA</summary>
export const Tipi_F_SOA: string = "F-SOA";
///<summary>File - Svincolo</summary>
export const Tipi_F_Svincolo: string = "F-Svincolo";
///<summary>File - Unico Persone</summary>
export const Tipi_F_UnicoPersone: string = "F-UnicoPersone";
///<summary>File - Unico Società</summary>
export const Tipi_F_UnicoSocieta: string = "F-UnicoSocieta";
///<summary>File - Visura Camerale</summary>
export const Tipi_F_VisuraCamerale: string = "F-VisuraCamerale";
///<summary>File - Visura Catastale</summary>
export const Tipi_F_VisuraCatastale: string = "F-VisuraCatastale";
///<summary>FileChiave - Anag</summary>
export const Tipi_FC_Anag: string = "FC-Anag";
///<summary>FileChiave - Binder</summary>
export const Tipi_FC_Binder: string = "FC-Binder";
///<summary>FileChiave - Dato economico</summary>
export const Tipi_FC_DatoEconomico: string = "FC-DatoEconomico";
///<summary>FileChiave - Fattura servizio recupero dati economici</summary>
export const Tipi_FC_FatturaDatiEconomici: string = "FC-FatturaDatiEconomici";
///<summary>FileChiave - FideAffidamento</summary>
export const Tipi_FC_FideAffidamento: string = "FC-FideAffidamento";
///<summary>FileChiave - FideCoobbligati</summary>
export const Tipi_FC_FideCoobbligati: string = "FC-FideCoobbligati";
///<summary>FileChiave - FideValutazione</summary>
export const Tipi_FC_FideValutazione: string = "FC-FideValutazione";
///<summary>FileChiave - Polizza</summary>
export const Tipi_FC_Polizza: string = "FC-Polizza";
///<summary>FileChiave - RCP</summary>
export const Tipi_FC_RCP: string = "FC-RCP";
///<summary>FileRichiesti - Affidamenti per fideiussioni non provvisorie</summary>
export const Tipi_FR_AffNonProvvisorie: string = "FR-AffNonProvvisorie";
///<summary>FileRichiesti - Affidamenti per fideiussioni provvisorie</summary>
export const Tipi_FR_AffProvvisorie: string = "FR-AffProvvisorie";
///<summary>FileRichiesti - Coobbligati per affidamenti</summary>
export const Tipi_FR_CoobAff: string = "FR-CoobAff";
///<summary>FileRichiesti - Coobbligati per polizze</summary>
export const Tipi_FR_CoobPol: string = "FR-CoobPol";
///<summary>FileRichiesti - Fideiussioni non provvisorie</summary>
export const Tipi_FR_NonProvvisorie: string = "FR-NonProvvisorie";
///<summary>FileRichiesti - Fideiussioni provvisorie</summary>
export const Tipi_FR_Provvisorie: string = "FR-Provvisorie";
///<summary>FileRichiesti - RCP</summary>
export const Tipi_FR_RCP: string = "FR-RCP";
///<summary>FileStati - File caricato</summary>
export const Tipi_FS_Caricato: string = "FS-Caricato";
///<summary>FileStati - File validato</summary>
export const Tipi_FS_Validato: string = "FS-Validato";
///<summary>FileStati - File caricato</summary>
export const Tipi_FS_Inviato: string = "FS-Inviato";
///<summary>FileStati - File validato</summary>
export const Tipi_FS_Firmato: string = "FS-Firmato";
///<summary>ForitoriDatiEconomici - Innolva</summary>
export const Tipi_FDE_Innolva: string = "FDE-Innolva";
///<summary>GruppiLimiti - Limite su importo affidamento non provvisorie</summary>
export const Tipi_GL_AffidamentoNonProvvisorie: string = "GL-AffidamentoNonProvvisorie";
///<summary>GruppiLimiti - Limite su importo affidamento provvisorie</summary>
export const Tipi_GL_AffidamentoProvvisorie: string = "GL-AffidamentoProvvisorie";
///<summary>GruppiLimiti - Limite su massimale</summary>
export const Tipi_GL_Massimale: string = "GL-Massimale";
///<summary>GruppiLimiti - Limite su premio</summary>
export const Tipi_GL_Premio: string = "GL-Premio";
///<summary>ListaApprovazioniRichieste - Appendice</summary>
export const Tipi_LAR_Appendice: string = "LAR-Appendice";
///<summary>ListaApprovazioniRichieste - Affidamenti</summary>
export const Tipi_LAR_FideAffidamento: string = "LAR-FideAffidamento";
///<summary>ListaApprovazioniRichieste - Affidamenti per i contraenti</summary>
export const Tipi_LAR_FideAffidamentoContraente: string = "LAR-FideAffidamentoContraente";
///<summary>ListaApprovazioniRichieste - Polizza</summary>
export const Tipi_LAR_Polizza: string = "LAR-Polizza";
///<summary>PolizzaApprovazione - Proposta</summary>
export const Tipi_PA_Proposta: string = "PA-Proposta";
///<summary>PolizzaApprovazione - Approvato con parere positivo</summary>
export const Tipi_PA_ApprovatoPositivo: string = "PA-ApprovatoPositivo";
///<summary>PolizzaApprovazione - Approvato con parere negativo</summary>
export const Tipi_PA_ApprovatoNegativo: string = "PA-ApprovatoNegativo";
///<summary>PolizzaCalcoloPremio - Calcolato in base ai parametri</summary>
export const Tipi_PCP_Calcolo: string = "PCP-Calcolo";
///<summary>PolizzaCalcoloPremio - Premio proposto dalla compagnia (special acceptance)</summary>
export const Tipi_PCP_Compagnia: string = "PCP-Compagnia";
///<summary>PolizzaCalcoloPremio - Premio proposto dal POS</summary>
export const Tipi_PCP_POS: string = "PCP-POS";
///<summary>PolizzaCalcoloPremio - Premio proposto dal sottoscrittore</summary>
export const Tipi_PCP_UW: string = "PCP-UW";
///<summary>PolizzaStato - Annullata</summary>
export const Tipi_PS_Annullata: string = "PS-Annullata";
///<summary>PolizzaStato - NP Annullata</summary>
export const Tipi_PS_NP_Annullata: string = "PS-NP-Annullata";
///<summary>PolizzaStato - Annullata senza effetto dall'origine</summary>
export const Tipi_PS_AnnullataSEO: string = "PS-AnnullataSEO";
///<summary>PolizzaStato - Preventivo non modificabile</summary>
export const Tipi_PS_Bloccata: string = "PS-Bloccata";
///<summary>PolizzaStato - NP Bozza accettata</summary>
export const Tipi_PS_NP_BozzaAccettata: string = "PS-NP-BozzaAccettata";
///<summary>PolizzaStato - Bozza accettata</summary>
export const Tipi_PS_BozzaAccettata: string = "PS-BozzaAccettata";
///<summary>PolizzaStato - NP Bozza emessa</summary>
export const Tipi_PS_NP_BozzaEmessa: string = "PS-NP-BozzaEmessa";
///<summary>PolizzaStato - Bozza emessa</summary>
export const Tipi_PS_BozzaEmessa: string = "PS-BozzaEmessa";
///<summary>PolizzaStato - NP Polizza emessa</summary>
export const Tipi_PS_NP_PolizzaEmessa: string = "PS-NP-PolizzaEmessa";
///<summary>PolizzaStato - Polizza emessa</summary>
export const Tipi_PS_Emessa: string = "PS-Emessa";
///<summary>PolizzaStato - Polizza emessa e firmata</summary>
export const Tipi_PS_Emessa_Firmata: string = "PS-EmessaFirmata";

///<summary>PolizzaStato - Polizza emessa e rinnovata</summary>
export const Tipi_PS_EmessaRinnovata: string = "PS-EmessaRinnovata";
///<summary>PolizzaStato - Quietanza di rinnovo emessa</summary>
export const Tipi_PS_EmessaRinnovataQ: string = "PS-EmessaRinnovataQ";
///<summary>PolizzaStato - Polizza in rinnovo</summary>
export const Tipi_PS_InRinnovo: string = "PS-InRinnovo";
///<summary>PolizzaStato - Polizza in rinnovo consolidato</summary>
export const Tipi_PS_InRinnovoConsolidata: string = "PS-InRinnovoConsolidata";
///<summary>PolizzaStato - Polizza in rinnovo approvata</summary>
export const Tipi_PS_InRinnovoApprovata: string = "PS-InRinnovoApprovata";

///<summary>PolizzaStato - NP Polizza sottoscritta</summary>
export const Tipi_PS_NP_PolizzaSottoscritta: string = "PS-NP-PolizzaSottoscritta";
///<summary>PolizzaStato - NP Preventivo di polizza</summary>
export const Tipi_PS_NP_Preventivo: string = "PS-NP-Preventivo";
///<summary>PolizzaStato - Polizza sottoscritta</summary>
export const Tipi_PS_PolizzaSottoscritta: string = "PS-PolizzaSottoscritta";
///<summary>PolizzaStato - NP Proposta riaperta</summary>
export const Tipi_PS_NP_PropostaRiaperta: string = "PS-NP-PropostaRiaperta";
///<summary>PolizzaStato - Polizza sottoscritta POS</summary>
export const Tipi_PS_PolizzaSottoscrittaPOS: string = "PS-PolizzaSottoscrittaPOS";
///<summary>PolizzaStato - Preventivo di polizza consolidato</summary>
export const Tipi_PS_Consolidata: string = "PS-Consolidata";
///<summary>PolizzaStato - NP Proposta rifiutata</summary>
export const Tipi_PS_NP_PropostaRifiutata: string = "PS-NP-PropostaRifiutata";
///<summary>PolizzaStato - Preventivo di polizza</summary>
export const Tipi_PS_Preventivo: string = "PS-Preventivo";
///<summary>PolizzaStato - Preventivo bozza inviata di polizza</summary>
export const Tipi_PS_PreventivoBozzaInviata = "PS-PreventivoBozzaInviata";
///<summary>PolizzaStato - Preventivo di polizza sottoposto al sottoscrittore</summary>
export const Tipi_PS_ConsolidataSottoscrittore: string = "PS-ConsolidataSottoscrittore";
///<summary>PolizzaStato - NP Proposta sospesa</summary>
export const Tipi_PS_NP_PropostaSospesa: string = "PS-NP-PropostaSospesa";
///<summary>PolizzaStato - Proposta riaperta</summary>
export const Tipi_PS_PropostaRiaperta: string = "PS-PropostaRiaperta";
///<summary>PolizzaStato - Preventivo di polizza approvato</summary>
export const Tipi_PS_Approvata: string = "PS-Approvata";
///<summary>PolizzaStato - NP Stornata</summary>
export const Tipi_PS_NP_Stornata: string = "PS-NP-Stornata";
///<summary>PolizzaStato - Proposta sospesa</summary>
export const Tipi_PS_PropostaSospesa: string = "PS-PropostaSospesa";
///<summary>PolizzaStato - NP Svincolata</summary>
export const Tipi_PS_NP_Svincolata: string = "PS-NP-Svincolata";
///<summary>PolizzaStato - Polizza postuma</summary>
export const Tipi_PS_Postuma: string = "PS-Postuma";
///<summary>PolizzaStato - Polizza prorogata</summary>
export const Tipi_PS_Prorogata: string = "PS-Prorogata";
///<summary>PolizzaStato - Preventivo di proroga</summary>
export const Tipi_PS_PreventivoProroga: string =  "PS-PreventivoProroga";
///<summary>PolizzaStato - Polizza rifiutata</summary>
export const Tipi_PS_Rifiuto: string = "PS-Rifiuto";
///<summary>PolizzaStato - NP Titolo emesso</summary>
export const Tipi_PS_NP_TitoloEmesso: string = "PS-NP-TitoloEmesso";
///<summary>PolizzaStato - Storno con imposte</summary>
export const Tipi_PS_StornoConImposte: string = "PS-StornoConImposte";
///<summary>PolizzaStato - Titolo emesso</summary>
export const Tipi_PS_TitoloEmesso: string = "PS-TitoloEmesso";
///<summary>PolizzaStato - NP Trattativa chiusa</summary>
export const Tipi_PS_NP_TrattativaChiusa: string = "PS-NP-TrattativaChiusa";
///<summary>PolizzaStato - Storno senza imposte</summary>
export const Tipi_PS_StornoSenzaImposte: string = "PS-StornoSenzaImposte";
///<summary>PolizzaStato - NP Titolo incassato</summary>
export const Tipi_PS_NP_TitoloIncassato: string = "PS-NP-TitoloIncassato";
///<summary>PolizzaStato - Titolo incassato</summary>
export const Tipi_PS_TitoloIncassato: string = "PS-TitoloIncassato";
///<summary>PolizzaStato - Trattativa chiusa</summary>
export const Tipi_PS_TrattativaChiusa: string = "PS-TrattativaChiusa";
///<summary>PolizzaStato - Polizza svincolata</summary>
export const Tipi_PS_Svincolata: string = "PS-Svincolata";
///<summary>PolizzaStato - Polizza svincolata</summary>
export const Tipi_PS_PreventivoSvincolato: string = "PS-PreventivoSvincolato";
///<summary>PolizzaStato - Polizza variata</summary>
export const Tipi_PS_Variata: string = "PS-Variata";
///<summary>PolizzaStato - Polizza variata</summary>
export const Tipi_PS_PreventivoVariata: string = "PS-PreventivoVariata";
///<summary>Provvigioni - Provvigione calcolata sugli accessori</summary>
export const Tipi_Provv_Accessori: string = "Provv-Accessori";
///<summary>Provvigioni - Provvigione calcolata sui diritti fissi</summary>
export const Tipi_Provv_Diritti: string = "Provv-Diritti";
///<summary>Provvigioni - Provvigione calcolata sul premio netto</summary>
export const Tipi_Provv_Netto: string = "Provv-Netto";
///<summary>Quietanza - Quietanza per un'appendice</summary>
export const Tipi_Q_Appendice: string = "Q-Appendice";
///<summary>Quietanza - Quietanza per l'intera polizza</summary>
export const Tipi_Q_Polizza: string = "Q-Polizza";
///<summary>Quietanza - Quietanza per una rata</summary>
export const Tipi_Q_Rata: string = "Q-Rata";
///<summary>Quietanza - Quietanza di storno con imposte</summary>
export const Tipi_Q_StornoConImposte: string = "Q-StornoConImposte";
///<summary>Quietanza - Quietanza di storno senza imposte</summary>
export const Tipi_Q_StornoSenzaImposte: string = "Q-StornoSenzaImposte";
///<summary>Quietanza - Quietanza di svincolo</summary>
export const Tipi_Q_Svincolo: string = "Q-Svincolo";
///<summary>Quietanza - Quietanza che non comporta pagamento</summary>
export const Tipi_Q_Zero: string = "Q-Zero";
///<summary>QuietanzaStato - Quietanza emessa</summary>
export const Tipi_QS_Emessa: string = "QS-Emessa";
///<summary>QuietanzaStato - Quietanza incassata</summary>
export const Tipi_QS_Incassata: string = "QS-Incassata";
///<summary>RapportoBinder - Agente-Coverholder</summary>
export const Tipi_Agente_Coverholder: string = "Agente-Coverholder";
///<summary>RapportoBinder - Broker-Compagnia</summary>
export const Tipi_Broker_Company: string = "Broker-Company";
///<summary>RapportoBinder - Broker-Coverholder</summary>
export const Tipi_Broker_Coverholder: string = "Broker-Coverholder";
///<summary>RapportoBinder - Collaborazione</summary>
export const Tipi_Collaborazione: string = "Collaborazione";
///<summary>RapportoBinder - Compagnia-Riassicuratore</summary>
export const Tipi_Company_ReIns: string = "Company-ReIns";
///<summary>RapportoBinder - Coverholder-Broker</summary>
export const Tipi_Coverholder_Broker: string = "Coverholder-Broker";
///<summary>RCPGA-GaranziaAccessoriaAgenti - Retroattivita</summary>
export const Tipi_RCPG_Accessoria_Retroattivita: string = "RCPG-Accessoria-Retroattivita";
///<summary>RCPGA-GaranziaAccessoriaAmministratoriCondominio - Postuma</summary>
export const Tipi_RCPG_Accessoria_Postuma: string = "RCPG-Accessoria-Postuma";
///<summary>RCPGA-GaranziaAccessoriaArchitetti - DanniATerziDaInterruzioneDiAttivita</summary>
export const Tipi_RCPG_Accessoria_DanniATerziDaInterruzioneAttivita: string = "RCPG-Accessoria-DanniATerziDaInterruzioneAttivita";
///<summary>RCPGA-GaranziaAccessoriaArchitetti - EffettuazioneDiOpereAdAltoRischio</summary>
export const Tipi_RCPG_Accessoria_EffettuazioneOpereAltoRischio: string = "RCPG-Accessoria-EffettuazioneOpereAltoRischio";
///<summary>RCPGA-GaranziaAccessoriaArchitetti - IncarichiprofessionaliInRegimeDiGeneralContractor</summary>
export const Tipi_RCPG_Accessoria_GeneralContractor: string = "RCPG-Accessoria-GeneralContractor";
///<summary>RCPGA-GaranziaAccessoriaAreaMedica - Danni Attrezzature di Laboratorio</summary>
export const Tipi_RCPG_Accessoria_DanniAttrezzatureLaboratorio: string = "RCPG-Accessoria-DanniAttrezzatureLaboratorio";
///<summary>RCPGA-GaranziaAccessoriaAreaMedica - Direzione Sanitaria</summary>
export const Tipi_RCPG_Accessoria_DirezioneSanitaria: string = "RCPG-Accessoria-DirezioneSanitaria";
///<summary>RCPGA-GaranziaAccessoriaAreaMedica - Medicina Estetica</summary>
export const Tipi_RCPG_Accessoria_MedicinaEstetica: string = "RCPG-Accessoria-MedicinaEstetica";
///<summary>RCPGA-GaranziaAccessoriaAreaMedica - PerditePatrimoniali</summary>
export const Tipi_RCPG_Accessoria_PerditePatrimoniali: string = "RCPG-Accessoria-PerditePatrimoniali";
///<summary>RCPGA-GaranziaAccessoriaAreaOdontoiatrica - Implantologia</summary>
export const Tipi_RCPG_Accessoria_Implantologia: string = "RCPG-Accessoria-Implantologia";
///<summary>RCPGA-GaranziaAccessoriaAreaOdontoiatrica - Neolaureati</summary>
export const Tipi_RCPG_Accessoria_Neolaureati: string = "RCPG-Accessoria-Neolaureati";

///<summary>RCPGA-GaranziaAccessoriaAvvocati - Funzioni Pubbliche</summary>
export const Tipi_RCPG_Accessoria_FunzioniPubbliche: string = "RCPG-Accessoria-FunzioniPubbliche";
///<summary>RCPGA-GaranziaAccessoriaAvvocati - Attivita fiscale tributaria e di revisione in Enti Pubblici</summary>
export const Tipi_RCPG_Accessoria_AttFiscRevEntiPubb: string = "RCPG-Accessoria-AttFiscRevEntiPubb";

///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - Sindaco di Societa e_o Membro Consiglio di Amministrazione</summary>
export const Tipi_RCPG_Accessoria_Sindaco: string = "RCPG-Accessoria-Sindaco";
///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - Funzione di revisione contabile</summary>
export const Tipi_RCPG_Accessoria_FunzioneRevisoreContabile: string = "RCPG-Accessoria-FunzioneRevisoreContabile";
///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - Funzione di revisione contabile in Enti Pubblici</summary>
export const Tipi_RCPG_Accessoria_FunzioneRevisoreContabileEP: string = "RCPG-Accessoria-FunzioneRevisoreContabileEP";
///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - Membro del condiglio di amministrazione</summary>
export const Tipi_RCPG_Accessoria_MembroCdA: string = "RCPG-Accessoria-MembroCdA";
///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - OCC Organismo per la composizione della crisi da sovraindebitamento</summary>
export const Tipi_RCPG_Accessoria_OCC: string = "RCPG-Accessoria-OCC";
///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - ODV Organismo di Vigilanza</summary>
export const Tipi_RCPG_Accessoria_ODV: string = "RCPG-Accessoria-ODV";
///<summary>RCPGA-GaranziaAccessoriaAvvocati&Comm - Amministratore di stabili condominiali</summary>
export const Tipi_RCPG_Accessoria_AmministratoreCondomini: string = "RCPG-Accessoria-AmministratoreCondomini";





///<summary>RCPGA-GaranziaAccessoriaCommercialisti - LiquidazioneCuratela</summary>
export const Tipi_RCPG_Accessoria_LiquidazioneCuratela: string = "RCPG-Accessoria-LiquidazioneCuratela";
///<summary>RCPGA-GaranziaAccessoriaCommercialisti - Visto Leggero</summary>
export const Tipi_RCPG_Accessoria_VistoLeggero: string = "RCPG-Accessoria-VistoLeggero";
///<summary>RCPGA-GaranziaAccessoriaCommercialisti - Visto Pesante</summary>
export const Tipi_RCPG_Accessoria_VistoPesante: string = "RCPG-Accessoria-VistoPesante";
///<summary>RCPGA-GaranziaAccessoriaCommercialisti - FusioniAcquisizioni</summary>
export const Tipi_RCPG_Accessoria_FusioniAcquisizioni: string = "RCPG-Accessoria-FusioniAcquisizioni";



///<summary>RCPGA-GaranziaAccessoriaIngegneri - EstensioneCodiceAppalti</summary>
export const Tipi_RCPG_Accessoria_EstensioneCodiceAppalti: string = "RCPG-Accessoria-EstensioneCodiceAppalti";
///<summary>RCPGA-GaranziaAccessoriaPeritiAssicurativi - PatrocinatoreStragiudiziale</summary>
export const Tipi_RCPG_Accessoria_PatrocinatoriStragiudiziali: string = "RCPG-Accessoria-PatrocinatoriStragiudiziali";
///<summary>RCPGA-GaranziaAccessoriaVeterinari - Colpa Grave</summary>
export const Tipi_RCPG_Accessoria_ColpaGrave: string = "RCPG-Accessoria-ColpaGrave";
///<summary>RCPGB-GaranziaBase - Polizza Agenti</summary>
export const Tipi_RCPG_BaseAgenti: string = "RCPG-BaseAgenti";
///<summary>RCPGB-GaranziaBase - Polizza AmministratoriCondominio</summary>
export const Tipi_RCPG_BaseAmministratoriCondominio: string = "RCPG-BaseAmministratoriCondominio";
///<summary>RCPGB-GaranziaBase - Polizza Architetti</summary>
export const Tipi_RCPG_BaseArchitetti: string = "RCPG-BaseArchitetti";
///<summary>RCPGB-GaranziaBase - Polizza AreaMedica</summary>
export const Tipi_RCPG_BaseAreaMedica: string = "RCPG-BaseAreaMedica";
///<summary>RCPGB-GaranziaBase - Polizza AreaOdontoiatrica</summary>
export const Tipi_RCPG_BaseAreaOdontoiatrica: string = "RCPG-BaseAreaOdontoiatrica";
///<summary>RCPGB-GaranziaBase - Polizza Avvocati</summary>
export const Tipi_RCPG_BaseAvvocati: string = "RCPG-BaseAvvocati";
///<summary>RCPGB-GaranziaBase - Polizza ColpaGrave</summary>
export const Tipi_RCPG_BaseColpaGrave: string = "RCPG-BaseColpaGrave";
///<summary>RCPGB-GaranziaBase - Polizza Commercialisti</summary>
export const Tipi_RCPG_BaseCommercialisti: string = "RCPG-BaseCommercialisti";
///<summary>RCPGB-GaranziaBase - Polizza Componenti Commissioni Giudicatrici</summary>
export const Tipi_RCPG_BaseComponentiCommissioniGiudicatrici: string = "RCPG-BaseComponentiCommissioniGiudicatrici";
///<summary>RCPGB-GaranziaBase - Polizza Consulenti del lavoro</summary>
export const Tipi_RCPG_BaseConsulentiLavoro: string = "RCPG-BaseConsulentiLavoro";
///<summary>RCPGB-GaranziaBase - Polizza Consulenti del lavoro Sindaci/Revisori/Membri CdA</summary>
export const Tipi_RCPG_BaseConsulentiLavoroRevisori: string = "RCPG-BaseConsulentiLavoroRevisori";
///<summary>RCPGB-GaranziaBase - Polizza Geologi</summary>
export const Tipi_RCPG_BaseGeologi: string = "RCPG-BaseGeologi";
///<summary>RCPGB-GaranziaBase - Polizza Geometri</summary>
export const Tipi_RCPG_BaseGeometri: string = "RCPG-BaseGeometri";
///<summary>RCPGB-GaranziaBase - Polizza Igienisti Dentali</summary>
export const Tipi_RCPG_BaseIgienistiDentali: string = "RCPG-BaseIgienistiDentali";
///<summary>RCPGB-GaranziaBase - Polizza Ingegneri</summary>
export const Tipi_RCPG_BaseIngegneri: string = "RCPG-BaseIngegneri";
///<summary>RCPGB-GaranziaBase - Polizza Mediatori</summary>
export const Tipi_RCPG_BaseMediatori: string = "RCPG-BaseMediatori";
///<summary>RCPGB-GaranziaBase - Polizza Miscellaneous</summary>
export const Tipi_RCPG_BaseMiscellaneous: string = "RCPG-BaseMiscellaneous";
///<summary>RCPGB-GaranziaBase - Polizza Patrocinatori</summary>
export const Tipi_RCPG_BasePatrocinatori: string = "RCPG-BasePatrocinatori";
///<summary>RCPGB-GaranziaBase - Polizza Periti</summary>
export const Tipi_RCPG_BasePeritiStandard: string = "RCPG-BasePeritiStandard";
///<summary>RCPGB-GaranziaBase - Polizza PeritoAgrario</summary>
export const Tipi_RCPG_BasePeritoAgrario: string = "RCPG-BasePeritoAgrario";
///<summary>RCPGB-GaranziaBase - Polizza RCAmministratori</summary>
export const Tipi_RCPG_BaseRCAmministratori: string = "RCPG-BaseRCAmministratori";
///<summary>RCPGB-GaranziaBase - Polizza RespServProtPrev</summary>
export const Tipi_RCPG_BaseRespServProtPrev: string = "RCPG-BaseRespServProtPrev";
///<summary>RCPGB-GaranziaBase - Polizza SanitariNonMedici</summary>
export const Tipi_RCPG_BaseSanitariNonMedici: string = "RCPG-BaseSanitariNonMedici";
///<summary>RCPGB-GaranziaBase - Polizza ServiziInformatici</summary>
export const Tipi_RCPG_BaseServiziInformatici: string = "RCPG-BaseServiziInformatici";
///<summary>RCPGB-GaranziaBase - Polizza Veterinari</summary>
export const Tipi_RCPG_BaseVeterinari: string = "RCPG-BaseVeterinari";
///<summary>SOA - I</summary>
export const Tipi_SOA_I: string = "SOA-I";
///<summary>SOA - II</summary>
export const Tipi_SOA_II: string = "SOA-II";
///<summary>SOA - III</summary>
export const Tipi_SOA_III: string = "SOA-III";
///<summary>SOA - III-bis</summary>
export const Tipi_SOA_IIIbis: string = "SOA-IIIbis";
///<summary>SOA - IV</summary>
export const Tipi_SOA_IV: string = "SOA-IV";
///<summary>SOA - IV-bis</summary>
export const Tipi_SOA_IVbis: string = "SOA-IVbis";
///<summary>SOA - V</summary>
export const Tipi_SOA_V: string = "SOA-V";
///<summary>SOA - VI</summary>
export const Tipi_SOA_VI: string = "SOA-VI";
///<summary>SOA - VII</summary>
export const Tipi_SOA_VII: string = "SOA-VII";
///<summary>SOA - VIII</summary>
export const Tipi_SOA_VIII: string = "SOA-VIII";
///<summary>TipiAnag - Agente</summary>
export const Tipi_TA_Agente: string = "TA-Agente";
///<summary>TipiAnag - Broker</summary>
export const Tipi_TA_Broker: string = "TA-Broker";
///<summary>TipiAnag - Compagnia</summary>
export const Tipi_TA_Compagnia: string = "TA-Compagnia";
///<summary>TipiAnag - Coverholder</summary>
export const Tipi_TA_Coverholder: string = "TA-Coverholder";
///<summary>TipiAnag - POS</summary>
export const Tipi_TA_POS: string = "TA-POS";
///<summary>TipiAnag - SubAgente</summary>
export const Tipi_TA_SubAgente: string = "TA-SubAgente";
///<summary>TipiAnag - Underwriter</summary>
export const Tipi_TA_Underwriter: string = "TA-Underwriter";
///<summary>TipiAnagPrincipale - Associazione temporanea di imprese</summary>
export const Tipi_TAP_ATI: string = "TAP-ATI";
///<summary>TipiAnagPrincipale - Beneficiario</summary>
export const Tipi_TAP_Beneficiario: string = "TAP-Beneficiario";
///<summary>TipiAnagPrincipale - PersonaFisica</summary>
export const Tipi_TAP_PersonaFisica: string = "TAP-PersonaFisica";
///<summary>TipiAnagPrincipale - DittaIndividuale/Professionista</summary>
export const Tipi_TAP_DittaIndividuale: string = "TAP-DittaIndividuale";
///<summary>TipiAnagPrincipale - PersonaGiuridica</summary>
export const Tipi_TAP_PersonaGiuridica: string = "TAP-PersonaGiuridica";
///<summary>TipiDurate - Giorni</summary>
export const Tipi_DFIDE_Giorni: string = "DFIDE-Giorni";
///<summary>TipiDurate - Mesi</summary>
export const Tipi_DFIDE_Mesi: string = "DFIDE-Mesi";
///<summary>TipiDurate - Anni</summary>
export const Tipi_DFIDE_Anni: string = "DFIDE-Anni";
///<summary>TipoTrad - null</summary>
export const Tipi_TT_AccreditedBDX: string = "TT-AccreditedBDX";

export const Tipi_ECS_Aperto: string = "ECS-Aperto";
export const Tipi_ECS_Chiuso: string = "ECS-Chiuso";
export const Tipi_QS_Contabilizzata: string = "QS-Contabilizzata";



// WEBPACK FOOTER //
// ./src/Globale.tsx